import { User } from '../data';
import DataController from '../data/data.controller';
import NavigationController from './navigation.controller';
import { syncAdminProductCatalog } from '../components/common/lists';

class ShelfController extends NavigationController {
    data = new DataController();
    isAuthenticated = null;
    user = null;

    async initialize() {}

    async componentDidMount() {
        this.isAuthenticated = await this.data.authenticate();
        this.user = User.getInstance();
        if (this.isAuthenticated) {
            await syncAdminProductCatalog();
        }
        await this.initialize();
    }
}

export default ShelfController;
